


















import { defineComponent, PropType, reactive } from '@vue/composition-api';
import { OlbLoader, OlbIcon } from '@olbbank/vue-components';
import axios from 'axios';

export type CurrentLanguage = 'de-DE' | 'en';

export interface Language {
	key: CurrentLanguage;
	name: string;
	aria: string;
}

export interface LanguageApiResponse {
	RedirectUrl: string;
	Language: string;
}

export default defineComponent({
	components: {
		OlbIcon,
		OlbLoader,
	},
	props: {
		languageApi: {
			type: String,
			required: true,
		},
		currentLanguage: {
			type: String as PropType<CurrentLanguage>,
			required: true,
		},
		languages: {
			type: Array as PropType<Language[]>,
			required: true,
		},
	},
	setup(props) {
		const state = reactive({
			isLoading: false,
		});

		function getCurrentLanguage() {
			return props.languages.find((lang) => lang.key === props.currentLanguage) as Language;
		}

		function getOtherLanguages() {
			return props.languages.filter((lang) => lang.key !== props.currentLanguage);
		}

		function handleSuccess(data: LanguageApiResponse) {
			state.isLoading = false;
			window.location.href = data.RedirectUrl;
		}

		function handleError(error: string) {
			state.isLoading = false;
			console.error('[OlbLanguage] could not reach API: ', error);
		}

		function postNewLanguage(value: string) {
			state.isLoading = true;
			const url = `${props.languageApi}${value}/`;
			axios
				.post<LanguageApiResponse>(url)
				.then((res) => handleSuccess(res.data))
				.catch((err) => handleError(err));
		}

		return {
			currentLang: getCurrentLanguage(),
			otherLanguages: getOtherLanguages(),
			postNewLanguage,
			state,
		};
	},
});
